//Configuration file
export const BASE_URL_ENDPOINT = process.env.REACT_APP_BASE_URL_ENDPOINT
export const AZURE_ID = process.env.REACT_APP_AZURE_ID
export const AZURE_HOST = process.env.REACT_APP_AZURE_HOST 
export const AZURE_TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
export const GRAPHMS_URI = process.env.REACT_APP_GRAPHMS_URI
export const SITE_URI = process.env.SITE_URI